import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { useContentOverflow, useCopyValue } from '../../../../../../hooks'
import { getQaSelector } from '../../../../../../utils/common'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import { FloatingTooltip } from '../../../../../Floating'
import { Link } from '../../../../../Link'
import Text from '../../../../../Text'

import * as styles from './ApplicantIdentityWidgetContactRow.module.css'

import CopyIcon from '../../../../../../icons/copy.svg'

function ApplicantIdentityWidgetContactRow({
  copyQaName,
  label,
  link,
  qaName,
  text,
  value,
}) {
  const { t } = useTranslation()

  const { overflow, setContentOverflowRef } = useContentOverflow({
    dep: [text],
  })

  const { copied, handleCopy } = useCopyValue({
    successNotificationKey: 'ProfileContactsWidget.CopiedNotificationKey',
    value,
  })

  return (
    <>
      <Text isSecondary className={styles.label}>
        {label}
      </Text>
      <div className={styles.contact}>
        <FloatingTooltip
          content={text}
          disabled={!overflow}
          placement={FLOATING_ELEMENT_PLACEMENT.top}
        >
          {link ? (
            <Link
              {...getQaSelector({ value: qaName })}
              className={styles.value}
              ref={setContentOverflowRef}
              to={link}
            >
              {text}
            </Link>
          ) : (
            <Text
              className={styles.value}
              disabled={!value}
              isSecondary={!value}
              qaName={qaName}
              ref={setContentOverflowRef}
            >
              {text}
            </Text>
          )}
        </FloatingTooltip>
        {value ? (
          <Button.Outlined
            isGrey
            beforeIconProps={{ Icon: CopyIcon }}
            className={styles.copyButton}
            disabled={copied}
            height={BUTTON_HEIGHT_32}
            qaName={copyQaName}
            tooltip={t(
              copied
                ? 'ProfileContactsWidget.CopyingBtnKey'
                : 'ProfileContactsWidget.CopyBtnKey'
            )}
            tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
            onClick={handleCopy}
          />
        ) : null}
      </div>
    </>
  )
}

export default ApplicantIdentityWidgetContactRow
